module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#rain",
      toString: function () {
        return this.url;
      }
    }